<template>
  <WidgetPanel v-if="success && !closed">
    <template #header>
      <div class="flex justify-between">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Geschenk für dich
        </h3>
        <button @click="close">
          <XMarkIcon class="flex-shrink-0 h-5 w-5 text-gray-400" />
        </button>
      </div>
    </template>
    <template #default>
      <div class="divide-y divide-gray-200">
        <div class="block hover:bg-gray-50">
          <div class="min-w-0 flex-1 flex items-center">
            <div class="flex items-center px-4 py-4 sm:px-6">
              <div class="min-w-0 flex-1 flex items-center">
                <p class="text-sm font-medium text-gray-600">
                  Zum Launch vom St. Audio Studio schenken wir dir unser großes Set aus 99 Methoden zum Reichweitenaufbau für deinen Podcast im Wert von 99 €. ➜ Erzähl es weiter!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </WidgetPanel>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue';
import { useFetchResources } from '@/client/actions';
import { useCreateResource } from '@/client/actions';

const SETTING_KEY = 'present_widget_closed';

const props = defineProps({podcast: Object});

const parent = computed(() => props.podcast.id);
const target = computed(() => '/api/podcasts/' + parent.value + '/settings');

const { results, fetch, success } = useFetchResources(target);

const filter = setting => setting.key == SETTING_KEY;
const closed = computed(() => results.value.filter(filter).length);

const update = {key: SETTING_KEY, value: 1};

const { resource, create } = useCreateResource(target, update);

const close = () => create(fetch);

const watcher = watch(target, (v, _) => fetch());
const mounted = onMounted(() => fetch());
</script>
